module.exports = __webpack_public_path__ + "static/about-content-image-4-694a71d399550962eaf7c7721ff38336.jpg";